/// <reference path="_references.ts"/>

module App.Chat {
	interface localScope extends ng.IScope {
		chat: ChatController;
		resetOffset: () => void;
		scrollToBottom: () => void;
		getOldMessages: () => void;
		hasNew: boolean;
	}
	export class ChatMessagesWrapperDirective {
		public restrict: string = 'E';
		public templateUrl: string = 'html/chat/chat-messages-wrapper.tpl.html';
		public require = ['^^chat'];
		public replace: boolean = true;

		constructor(private $timeout: ng.ITimeoutService) {}

		public link(
			$scope: localScope,
			$element: ng.IAugmentedJQuery,
			$attrs: ng.IAttributes,
			controllers: any[]
		): void {
			$scope.chat = controllers[0];
			$scope.hasNew = false;

			let offset = null,
				oldHeight = null,
				updateTop = false,
				e = $element[0];

			$scope.scrollToBottom = () => this.$timeout(() => {
				const newTop = e.scrollHeight - e.clientHeight;

				if (updateTop) {
					e.scrollTop = e.scrollHeight - oldHeight;
				} else if (offset === null || e.scrollTop >= offset || $scope.chat.isLastOutbound()) {
					e.scrollTop = newTop;
					$scope.hasNew = false;
				} else {
					$scope.hasNew = true;
				}

				offset = newTop;
				oldHeight = e.scrollHeight;

				updateTop = false;
			}, 0);

			$scope.$watch(
				() => e.scrollTop,
				scrollTop => scrollTop >= offset && ($scope.hasNew = false)
			);

			$scope.$watch(
				() => $scope.chat.usersOpen,
				open => open && (offset = null)
			);

			$scope.getOldMessages = () => {
				updateTop = true;
				$scope.chat.getOldMessages();
			};
		}
	}
}
